import { IRequestOptions } from "../IRequestOptions";
import { tms } from "../tms";
import { IRequestHandler, request } from "@fanfanlo";
import { emergencyCallContactService } from "./list_established_contacts";

/**
 * 获取所有邀请的请求参数
 */
export interface IParamsListAllInvitations {
  // 可以添加分页等参数
  page?: number;
  page_size?: number;
}

/**
 * 用户信息
 */
export interface IInvitationUserInfo {
  user_id: string;
  display_name: string;
  avatar_url?: string;
}

// 邀请状态类型
export type InviteStatus = 'pending' | 'accepted' | 'declined' | 'expired' | 'cancelled';

// 邀请记录详情
export interface IInvitationDetails {
  invitation_id: string;
  user_info: {
    user_id: string;
    display_name: string;
    avatar_url?: string;
  };
  status: InviteStatus;
  message: string;
  created_at: number;
  expires_at: number;
}

/**
 * 获取所有邀请的响应结果
 */
export interface IResultListAllInvitations {
  is_ok: boolean;
  msg?: string;
  sent_invitations: IInvitationDetails[];
  received_invitations: IInvitationDetails[];
}

/**
 * 响应邀请的请求参数
 */
export interface IParamsRespondToInvite {
  invitation_id: string;
  action: 'accept' | 'decline' | 'cancel' | 'remove';
}

/**
 * 获取所有邀请（发送和接收的）
 */
export async function tmsEmergencyCallListAllInvitations(
  opts: IRequestOptions<IParamsListAllInvitations>
) {
  return request<IResultListAllInvitations, IParamsListAllInvitations>(
    tms.TEmc,
    tms.MEmcListAllInvitations,
    opts.params,
    opts.gateway,
    opts.handler
  );
}

/**
 * 取消邀请或删除已建立的联系人关系
 * @param invitationId 邀请ID
 * @param isReceived 是否是接收的邀请
 * @param inviteStatus 邀请状态 - 用于判断是取消邀请还是删除关系
 * @returns Promise
 */
export async function cancelOrRemoveInvitation(
  invitationId: string,
  isReceived: boolean,
  inviteStatus?: InviteStatus
) {
  // 如果是已接受的邀请，使用remove操作删除联系人关系
  if (inviteStatus === 'accepted') {
    return emergencyCallInvitationService.respondToInvite({
      params: {
        invitation_id: invitationId,
        action: 'remove'
      }
    } as any);
  }

  // 对于pending状态的邀请，使用cancel操作
  const action = 'cancel';
  return emergencyCallInvitationService.respondToInvite({
    params: {
      invitation_id: invitationId,
      action
    }
  } as any);
}

/**
 * 响应邀请
 */
export async function tmsEmergencyCallRespondToInvite(
  opts: IRequestOptions<IParamsRespondToInvite>
) {
  return request<{ is_ok: boolean; msg?: string }, IParamsRespondToInvite>(
    tms.TEmc,
    tms.MEmcRespondToInvite,
    opts.params,
    opts.gateway,
    opts.handler
  );
}

// 导出所有接口
export const emergencyCallInvitationService = {
  listAllInvitations: tmsEmergencyCallListAllInvitations,
  respondToInvite: tmsEmergencyCallRespondToInvite,
};

export default emergencyCallInvitationService;
